import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const AboutUsThunk = createAsyncThunk(
	"AboutUs/AboutUsThunk",

	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const url = `https://api.raj.com.sa/api/public/about_us`;

			const res = await axios.get(url, {
				headers: {
					Locale: localStorage.getItem("language") || navigator?.languages?.[1],
				},
			});

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data?.data);
		}
	}
);
